import React, { useEffect, useState } from "react";
import { Col, Row, FormGroup, Container, Button } from "reactstrap";
import { Field, Form } from "react-final-form";
import {
  useDispatch,
  flashError,
  flashSuccess,
  flash,
} from "@/shared/components/flash";
import axios from "axios";
import { connect } from "react-redux";
import Select from 'react-select';
import getCsvImportTypeOptions from '@/services/getCsvImportTypeOptions'
import getCsvImportTypeFields from '@/services/getCsvImportTypeFields'

import {labelizeNamedData} from "@/shared/helpers";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import FormStep1 from "./FormStep1";
import FormStep2 from "./FormStep2";
import ImportDataTable from "./ImportDataTable";
import ImportResults from "./ImportResultsTable";
import getCsvImportSettings from '@/services/getCsvImportSettings';

const isValidResponse = (data) => {
  if (!data.hasOwnProperty("CSVheaders")) return false;
  if (!data.hasOwnProperty("fieldsToMap")) return false;
  // Add more validation here
  return true;
};

let config = {
  importType: {
    name: "import_type",
    label: "Select Import Type",
    options: [
      {
        label: "Events",
        value: "Events",
      },
      {
        label: "Programs",
        value: "Programs",
      },
      {
        label: "Users",
        value: "Users",
      },
    ],
    // placeholder: null
  },
  importFile: {
    name: "import_file",
    label: "Choose File",
  },
  importTypeStep2: {
    name: "import_type",
    label: "Select Import Type",
    options: [
      {
        label: "Users",
        value: "Users",
      },
    ],
    placeholder: " ----- ",
  },
  userRole: {
    name: "user_role",
    label: "Select User Role",
    options: [
      {
        label: "Participant",
        value: "Participant",
      },
      {
        label: "Manager",
        value: "Manager",
      },
    ],
    placeholder: " ----- ",
  },
};

const makeOptions = (obj) => {
  let newOptions = [];
  for (const [key, fields] of Object.entries(obj)) {
    let newOption = {
      label: key,
      options: [{ label: '— Select —', value: '', description: '' }]
    };
    for (const [name, fieldData] of Object.entries(fields)) {
      newOption.options.push({
        label: fieldData?.display_name || name,
        value: key + name,
        description: fieldData?.description || ''
      });
    }
    newOptions.push(newOption);
  }
  return newOptions;
};

const Import = ({ organization, program }) => {
  const [loading, setLoading] = useState(false);
  const [typeOptionsLoading, setTypeOptionsLoading] = useState(true);
  const [importType, setImportType] = useState(null); //extend it later
  const [csvImportType, setCsvImportType] = useState(null); //extend it later
  const [csvImportTypeType, setCsvImportTypeType] = useState("award_users"); //extend it later
  const [csvImportTypes, setCsvImportTypes] = useState("award_users"); //extend it later
  const [csvImportTypeOptions, setCsvImportTypeOptions] = useState([]); //extend it later
  const [importHeaders, setImportHeaders] = useState(null);
  const [selectedImportTypeOption, setSelectedImportTypeOption] = useState(null);
  const [csvImportTypeFields, setCsvImportTypeFields] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [showImportSettings, setShowImportSettings] = useState(false);
  const [step, setStep] = useState(0);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [processingImport, setProcessingImport] = useState(false);
  const [saveSettings, setSaveSettings] = useState(false);
  const [importId, setImportId] = useState(null);
  const [mappedFields, setMappedFields] = useState({});
  const [savedSettings, setSavedSettings] = useState(null);

    const buildInitialFieldsToMap = (headers, savedSettings) => {
        if (!headers?.fieldsToMap) return {};
        
        // ✅ use savedSettings.field_mapping instead of headers.fieldMapping
        const mapping = savedSettings?.field_mapping;
        if (!mapping) return {};

        const allOptions = makeOptions(headers.fieldsToMap).flatMap(g => g.options);
        const result = {};

        Object.keys(mapping).forEach((formRequest) => {
            Object.keys(mapping[formRequest]).forEach((fieldKey) => {
            const csvHeader = mapping[formRequest][fieldKey];
            const option = allOptions.find(
                opt => opt.value !== '' && opt.value === formRequest + fieldKey
            );
            if (option && csvHeader) {
                result[csvHeader] = option;
            }
            });
        });
        return result;
    };
    useEffect(() => {
    if (organization?.id && program?.id && csvImportType?.id) {
        getCsvImportSettings(organization.id, program.id, csvImportType.id)
        .then(data => {
            setSavedSettings(data);
        });
    }
    }, [organization, program, csvImportType]);
    useEffect(() => {
        if (importHeaders && savedSettings) {
            setMappedFields(buildInitialFieldsToMap(importHeaders, savedSettings));
        } else {
            setMappedFields({});
        }
    }, [importHeaders, savedSettings]);

  useEffect( () => {
    if( organization?.id )  
    {
      if( step == 0 ) {
        getCsvImportTypeOptions(organization.id, program.id, {'context': importType})
        .then( res => {
          setCsvImportTypes(res) //set raw
          let tmpCsvImportTypeOptions = labelizeNamedData(res, ['type', 'name'])
          // tmpCsvImportTypeOptions = tmpCsvImportTypeOptions.map(obj => {
          //   if( obj.value === 'award_users' || obj.value === 'add_and_award_users') return obj;
          //   obj.disabled = true
          //   return obj
          // })
          // ❌ Remove Some options
          const removeValues = ['award_users', 'add_and_award_users', 'add_programs', 'add_managers', 'deactivate_participants', 'add_events'];

          tmpCsvImportTypeOptions = tmpCsvImportTypeOptions.filter(
            option => !removeValues.includes(option.value)
          );

          setCsvImportTypeOptions( tmpCsvImportTypeOptions )
          //console.log(tmpCsvImportTypeOptions)
          setTypeOptionsLoading(false)
        })
      }
    }
  }, [organization, step])

  useEffect(() => {
    // console.log(selectedImportTypeOption)
    if( selectedImportTypeOption?.value ) {
      const _csvImportType = csvImportTypes.find( t => t.type === selectedImportTypeOption.value)
      if( _csvImportType?.id ) {
        setCsvImportType(_csvImportType)
        getCsvImportTypeFields(organization.id, _csvImportType.id)
        .then( res => {
          // console.log(res)
          setCsvImportTypeFields(res.fields)
        })
      }
    }
  }, [selectedImportTypeOption]);

  const dispatch = useDispatch();

  const reset = () => {
    setStep(1);
    setCsvFile(null);
    setImportHeaders(null);
    setImportType("");
    setError(null);
    setProcessing(false);
    setSaveSettings(false);
  };
  const onclickBack = () => {
    setStep(step - 1);
    setProcessing(false);
  };
  const onclickNext = () => {
    setStep(step + 1);
  };

  const onSelectCsvFile = async (file) => {
    try {
      let data = new FormData();
      data.append("upload-file", file);
        setProcessing(true);
      const url = `/organization/${organization.id}/program/${program.id}/importtype/${csvImportType.id}/importheaders`;
      axios
      .post(url, data, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (!isValidResponse(res.data)){
          flashError(dispatch, "Cannot read or invalid CSV file");
            setProcessing(false); 
          return;
        }
        if (!res.data.needToMatchFileds) {
          setShowImportSettings(true);
          setImportHeaders({
            ...res.data
          });
        }

        setCsvFile(file);
        setProcessing(false);
      })
      .catch((error) => {
        console.log(error);
        const errors = error?.response?.data?.errors;
        setProcessing(false); 
        flashError(dispatch, errors);
      });
    } catch (err) {
      console.error('CSV upload error:', err);
        setProcessing(false); 
    }
  };

  const onclickImportSettings = () => {
    setStep(2);
    setImportHeaders(prev => ({
      ...prev,
      isSaveSettings: true,
    }));
  };

  // const csvImportTypeOptions = [
  //   { label: "Award Participants", value: "award_users" },
  // ];

  const validate = (values) => {
    let errors = {};
    if (step === 1) {
      if (!importType) {
        errors.import_type = "Please select import type";
      }
      if (!csvFile) {
        errors.import_file = "Csv file is required";
      }
    } else if (step === 2) {
      // if(values.hasOwnProperty('fieldsToMap'))
      // {
      //   errors['fieldsToMap']['ProgramID'] = 'Some error';
      // }
      // console.log(errors)
    }
    // alert(JSON.stringify(values))
    return errors;
  };

  const onSubmitStep1 = (values) => {
    let data = new FormData();
    setProcessing(true);
    // const prefix = importType.toLowerCase().substring(0, importType.length - 1)
    let prefix = csvImportTypeType
      .toLowerCase()
      .substring(0, csvImportTypeType.length - 1)
      .replace("_", "");
    // console.log(prefix)
    data.append("upload-file", csvFile);
    const url = `/organization/${organization.id}/program/${program.id}/importtype/${csvImportType.id}/importheaders`;
    // console.log(url)
    axios
      .post(url, data, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (!isValidResponse(res.data)) {
          flashError(dispatch, "Cannot read or invalid CSV file");
            setProcessing(false)
          return;
        }

        if (res.data.needToMatchFileds) {
          setStep(2);

          setImportHeaders({
            ...res.data,
            isSaveSettings: true,
          });
        } else {
          let url = `/organization/${organization.id}/program/${program.id}/importtype/${csvImportType.id}/import`;
          setProcessing(true)

          axios
            .post(url, data, {
              headers: {
                "Content-type": "multipart/form-data",
              },
            })
            .then((res) => {
              if(res.data?.success){
                setImportId(res.data.csvImport.id);
                flashSuccess(
                  dispatch,
                  "Import request was processed. See below the import results."
                );
              }
              setProcessing(false)
            })
            .catch((error) => {
              const errors = error.response.data.errors;
              setError(errors);
              setSaveSettings(false);
              //   alert(JSON.stringify(errors))
              flashError(
                dispatch,
                "There were errors. Scroll down the page to view."
              );
              setProcessing(false)
            });
        }
      })
      .catch((error) => {
        console.log(error);
        const errors = error?.response?.data?.errors;
        flashError(dispatch, errors);
        setProcessing(false);
      });
  };

  const onSubmitStep2 = (values) => {

    const isSaveSettings = !!values.isSaveSettings;

    if (
      !values ||
      !importHeaders ||
      !values.hasOwnProperty("fieldsToMap") ||
      !(csvFile instanceof File)
    ) {
      flashError(dispatch, "Invalid data found");
      setSaveSettings(false);
      return;
    }
    // console.log(values)

    if (isSaveSettings) {
        setProcessing(true);          // Save Settings loader
    } else {
        setProcessingImport(true);    // Import loader
    }

    const formFields = values.fieldsToMap;

    let newFormFields = {};
    for (const [formRequest, headerFieldsToMap] of Object.entries(
      importHeaders.fieldsToMap
    )) {
      newFormFields[formRequest] = {};
      for (const [fieldName] of Object.entries(headerFieldsToMap)) {
        for (const [formFieldName, formFieldValue] of Object.entries(formFields)) {
          if (formFieldValue == null) {
            continue;
          }
          const rawValue =
            typeof formFieldValue === "object" &&
            formFieldValue !== null &&
            "value" in formFieldValue
              ? formFieldValue.value
              : formFieldValue;

          if (rawValue == null) {
            continue;
          }
          const valueStr =
            typeof rawValue === "string" ? rawValue : String(rawValue);

          const tmpFormRequest = valueStr.slice(0, formRequest.length);
          const tmpFormFieldValue = valueStr.slice(formRequest.length);

          if (
            tmpFormRequest &&
            tmpFormFieldValue &&
            tmpFormFieldValue === fieldName
          ) {
            // на всякий случай, если ключа ещё нет
            if (!newFormFields[tmpFormRequest]) {
              newFormFields[tmpFormRequest] = {};
            }

            newFormFields[tmpFormRequest][fieldName] = formFieldName;
          }
        }
      }
    }


    let type = "";
    let setupsFields = {};

    // Заполняем setupsFields значениями из формы, если они есть
    if (values.hasOwnProperty("setups")) {
      const setups = values["setups"];
      Object.keys(setups).map((formRequest) => {
        setupsFields[formRequest] = {};
        const fields = setups[formRequest];
        if (Object.keys(fields).length > 0) {
          Object.keys(fields).map((field) => {
            if (field === "type") {
              type = fields[field].value;
            }
            if (fields[field]) {
              setupsFields[formRequest][field] = fields[field].value;
            }
          });
        }
      });
    }

    // console.log(newFormFields)
    let data = new FormData();
    // const prefix = importType.toLowerCase().substring(0, importType.length - 1)
    let prefix = csvImportTypeType
      .toLowerCase()
      .substring(0, csvImportTypeType.length - 1)
      .replace("_", "");
    data.append("upload-file", csvFile);
    data.append("fieldsToMap", JSON.stringify(newFormFields));
    // Отправляем setups, если они есть в importHeaders, даже если пустые
    if (importHeaders && importHeaders.hasOwnProperty("setups") && Object.keys(importHeaders.setups).length > 0) {
      data.append("setups", JSON.stringify(setupsFields));
    }

    let url = '';

    if (isSaveSettings) {
      url = `/organization/${organization.id}/program/${program.id}/csv-import-setting/${csvImportType.id}`;
    }else{
      url = `/organization/${organization.id}/program/${program.id}/importtype/${csvImportType.id}/import`;
    }

    axios
      .post(url, data, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        if(!isSaveSettings && res.data?.success){
          setImportId(res.data.csvImport.id);
          flashSuccess(
            dispatch,
            "Import request was processed. See below the import results."
          );
        }
        if (isSaveSettings) {
          if (res.data?.success) {
            flashSuccess(dispatch, "Settings successfully saved");
            setSaveSettings(false);
            setProcessing(false)
          }
        }
        if (isSaveSettings) {
            setProcessing(false);
        } else {
            setProcessingImport(false);
        }
      })
      .catch((error) => {
        const errors = error.response.data.errors;
        setError(errors);
        setSaveSettings(false);
        //   alert(JSON.stringify(errors))
        flashError(
          dispatch,
          "There were errors. Scroll down the page to view."
        );
        setProcessing(false)
        setProcessingImport(false);
      });
    // return newFormFields;
  };

  const onSubmit = (values) => {
    if (step === 1) {
      onSubmitStep1(values);
    } else if (step === 2) {
      onSubmitStep2(values);
    }
  };



    const onChangeCsvImportType = (selectedOption) => {
        if (selectedOption) {
            setImportType(selectedOption.value);
            setStep(1);
            // Reset state from previous selection
            setCsvFile(null);
            setImportHeaders(null);
            setShowImportSettings(false);
            setProcessing(false);
            setError(null);
            setImportId(null);
            setSaveSettings(false);
            setMappedFields({});
        }
    };

  const onSelectImportTypeOption = (selectedOption, input) => {
      setSelectedImportTypeOption(selectedOption)
      input.onChange(selectedOption);
      //console.log(selectedOption)
  }


  // console.log(step)
  // console.log(csvImportType)

  return (
    <>
      <div className="manager-csv-import full-width">
        <Container className="px-0">
          <Form
            onSubmit={onSubmit}
            validate={validate}
            initialValues={{
              import_type: importType,
              import_file: csvFile,
              csv_import_type: selectedImportTypeOption ?? null,
              fieldsToMap: mappedFields,
            }}
            enableReinitialize
            keepDirtyOnReinitialize
          >
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit}>
                <Row className="pt-0 mt-0">
                  <Col>
                    <div className="form__form-group-field mb-4" style={{maxWidth:400}}>
                      <Field name={'csv_import_type'}
                        parse={
                          (value) => {
                            onChangeCsvImportType(value)
                            return value
                          }
                        }
                      >
                        {({ input, meta }) => (
                          <div className="form__form-group">
                            <div className="d-flex align-items-center">
                                <h4 className="mb-1 d-flex align-items-center">
                                    {"Csv Import Type"}

                                    <Tooltip
                                    title="Choose the type of CSV import. Different import types process data differently."
                                    arrow
                                    placement="right"
                                    >
                                    <IconButton size="small" style={{ padding: 4, marginLeft: 6 }}>
                                        <InfoOutlinedIcon style={{ fontSize: 18 }} />
                                    </IconButton>
                                    </Tooltip>

                                </h4>
                                </div>

                                <small>Select Import Type and .csv File</small>

                            <div className="form__form-group-field mt-2">
                              <div className="form__form-group-row">
                                <Select
                                  options={csvImportTypeOptions}
                                  isClearable={false}
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  isLoading={typeOptionsLoading}
                                  isOptionDisabled={(option) => option.disabled}
                                  {...input}
                                  onChange={(selectedOption) => onSelectImportTypeOption(selectedOption, input)}
                                />
                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                              </div>
                            </div>
                          </div>
                        )}
                      </Field>
                    </div>
                    {step === 1 && (
                      <>
                        <FormStep1
                          {...{
                            config,
                            setStep,
                            csvFile,
                            onSelectCsvFile,
                            onclickBack,
                            onclickNext,
                            importHeaders,
                            processing,
                            showImportSettings,
                            onclickImportSettings,
                            csvImportType,
                            organization,
                            program
                          }}
                        />
                        {/* {csvImportTypeFields && !importId &&
                          <div className="points-summary-table">
                            <ImportDataTable TABLE_COLUMNS={csvImportTypeFields} csvImportType={csvImportType} />
                          </div>
                        } */}
                      </>
                    )}
                    {step === 2 && (
                        <FormStep2
                                                {...{
                                                  config, setStep, csvFile, onclickBack, importHeaders,
                                                  isValidResponse, setSaveSettings, saveSettings, handleSubmit,
                                                  csvImportType, program, processing,processingImport, form, importId,
                                                  makeOptions, 
                                                    savedSettings,
                                                  onFieldChange: (fieldName, option) => {
                                                    setMappedFields(prev => ({ ...prev, [fieldName]: option }));
                                                }
                                                }}
                                              />
                    )}
                    {importId && (
                      <div className="points-summary-table">
                        <ImportResults organization={organization} id={importId} />
                      </div>
                    )}
                    {error && <ErrorComponentRaw error={error} />}
                  </Col>
                </Row>
                <Row>
                  <Col></Col>
                </Row>
              </form>
            )}
          </Form>
        </Container>
      </div>
    </>
  );
};
const ErrorComponentRaw = ({ error }) => {
  return (
    <div className="">
      <h4 className="mb-2">Import Errors</h4>
      <div className="p-3 text-danger">{JSON.stringify(error)}</div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    program: state.program,
    organization: state.organization,
  };
};
export default connect(mapStateToProps)(Import);
